<script lang="ts">
import Button1XP from '../../../Button1XP/Button1XP.vue';
import type { WindowWika } from '../../../../types/window';
import { useStoreTranslations } from '../../../../store/translations/translations';

type Props = {
  captionLeft?: boolean;
  hasNoPagination?: boolean;
  heightFirst?: boolean;
  image: string;
  imageHeight?: string;
  imageWidth?: string;
  isShopLink?: boolean;
  newWindow?: boolean;
  text?: string;
  title?: string;
  type?: 'video' | string;
  url?: string;
  slideIndex?: number;
  alt?: string;
};
</script>

<script setup lang="ts">
const storeTranslations = useStoreTranslations(); // TODO:  translation should be 'Mehr erfahren' and 'Zum Produkt'

defineProps<Props>();

const _window = window as unknown as WindowWika;
const wtTrack = _window.wtTrack;
</script>

<template>
  <div :class="[$style.container, heightFirst && $style.heightFirst]">
    <video
      v-if="type === 'video'"
      autoplay
      :class="$style.video"
      v-bind="{
        fetchpriority: slideIndex === 0 ? 'high' : 'auto',
      }"
      :height="imageHeight"
      loop
      muted
      :width="imageWidth"
    >
      <source :src="image" type="video/mp4" />
    </video>
    <img
      v-else
      :alt="alt || title || ''"
      :class="$style.image"
      :height="imageHeight"
      :loading="slideIndex !== 0 ? 'lazy' : 'eager'"
      v-bind="{
        fetchpriority: slideIndex === 0 ? 'high' : 'auto',
      }"
      :src="image"
      :width="imageWidth"
    />

    <div :class="$style.content">
      <div
        v-if="title || text || url"
        :class="[
          $style.caption,
          captionLeft ? $style.captionLeft : $style.captionRight,
          hasNoPagination && $style.hasNoPagination,
        ]"
      >
        <div v-if="title || text" :class="$style.captionText">
          <div v-if="title" :class="$style.title" v-html="title" />
          <div v-if="text" :class="$style.text" v-html="text" />
        </div>
        <Button1XP
          v-if="url"
          :class="$style.button"
          end-icon="arrow_forward"
          size="s"
          :target="newWindow ? 'blank' : undefined"
          :text="
            isShopLink
              ? storeTranslations.translations?.['heroSlider.slide.toProduct']
              : storeTranslations.translations?.['global.readMore']
          "
          :url="url"
          variant="secondary"
          @click="isShopLink && wtTrack?.({ cat: 'TOONLINESHOP' })"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module src="./Slide.scss" />
